import Axios from './require';

export default ({url,data,options}) => {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      data,
      options
    }).then(dt => {
      resolve(dt)
    }).catch(err => {
      reject(err)
    })
  })
}